import {
  afterNextRender,
  Component,
  computed,
  inject,
  model,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { injectNavigationEnd } from 'ngxtension/navigation-end';
import { CenterRoleStore } from '../../../../../stores/center/role.store';

type Segment = 'sales' | 'salary';

@Component({
  selector: 'app-accounting',
  templateUrl: './accounting.layout.html',
  imports: [CommonModule, RouterOutlet, RouterLink],
})
export default class AccountingLayout {
  readonly router = inject(Router);
  readonly navigationEnd$ = injectNavigationEnd();
  readonly roleStore = inject(CenterRoleStore);

  readRole = computed(
    () =>
      this.roleStore.administrationReadSelf() ||
      this.roleStore.administrationRead(),
  );

  segment = model<Segment>('sales');
  constructor() {
    afterNextRender(() => {
      this.setSegment();
      this.navigationEnd$.subscribe({
        next: () => this.setSegment(),
      });
    });
  }

  setSegment() {
    const url = this.router.url;

    if (url.includes('sales')) {
      this.segment.set('sales');
    } else if (url.includes('salary')) {
      this.segment.set('salary');
    }
  }
}
